<template>
	<div id="data-list-list-view" class="data-list-container">
		<div class="flex items-center justify-between">
			<vs-dropdown vs-trigger-click class="md:w-1/6 cursor-pointer items-per-page-handler mr-base">
				<div
					class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-center font-medium"
				>
					<span class="mr-2"
						>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
						{{
							listCompanies.length - currentPage * itemsPerPage > 0
								? currentPage * itemsPerPage
								: listCompanies.length
						}}
						of {{ queriedItems }}</span
					>
					<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
				</div>
				<vs-dropdown-menu>
					<vs-dropdown-item @click="itemsPerPage = 12">
						<span>12</span>
					</vs-dropdown-item>
					<vs-dropdown-item @click="itemsPerPage = 24">
						<span>24</span>
					</vs-dropdown-item>
					<vs-dropdown-item @click="itemsPerPage = 36">
						<span>36</span>
					</vs-dropdown-item>
					<vs-dropdown-item @click="itemsPerPage = 48">
						<span>48</span>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
			<vs-pagination :total="totalPages" :max="itemsPerPage" v-model="currentPage" />
		</div>
		<div class="flex flex-wrap items-center justify-end">
			<template>
				<!-- ITEMS PER PAGE -->
				<div class="vx-row mt-2">
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
						>
							<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="setSearchField('Nit')">
								<span>Nit</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Name')">
								<span>{{ $t("ResourceModule.Table.Name") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Address')">
								<span>{{ $t("ResourceModule.Table.Address") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('City')">
								<span>{{ $t("ResourceModule.Table.City") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</template>
			<vx-tooltip
				class="cursor-pointer md:w-1/3 w-full mt-2 ml-3"
				color="primary"
				position="bottom"
				delay=".1s"
				:title="$t('Search')"
				:text="$t('SearchSeparatedByCommas') + '.'"
			>
				<tags-input
					element-id="tags"
					v-model="searchQuery"
					add-tags-on-comma
					add-tags-on-blur
					:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
					:typeahead="true"
					@keyup.enter="searchCompany"
				></tags-input>
			</vx-tooltip>
			<div class="flex justify-between items-center mt-2">
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-search"
					:title="$t('VisitPoints.Search')"
					@click.prevent="searchCompany"
				></vs-button>
				<vs-button
					class="ml-2 mr-2"
					color="primary"
					icon-pack="feather"
					icon="icon-refresh-cw"
					:title="$t('Refresh')"
					@click.prevent="refresh()"
				></vs-button>
				<vs-dropdown
					vs-custom-content
					:vs-trigger-click="true"
					class="cursor-pointer"
					:title="$t('Setting.Setting')"
				>
					<vs-button type="filled" icon-pack="feather" icon="icon-settings"></vs-button>
					<vs-dropdown-menu style="width: 30%">
						<vx-card no-shadow :title="$t('Setting.Setting')">
							<div class="flex flex-row justify-between p-1">
								<p class="mr-2">{{ $t("Preferences.FindExactly") }}</p>
								<vs-switch color="success" v-model="isExactly" @input="openEnableConfirm"></vs-switch>
							</div>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</div>
		<div class="vx-row mt-base">
			<div
				class="vx-col w-full sm:w-1/1 md:w-1/2 mb-base"
				:class="[
					{'lg:w-1/4': windowWidth >= 1920},
					{'lg:w-1/3': windowWidth >= 1366 && windowWidth < 1920},
					{'lg:w-1/2': windowWidth >= 1366 && windowWidth < 1366},
				]"
				:key="indextr"
				v-for="(tr, indextr) in listCompaniesPage"
			>
				<CompanyListViewItemCardVue
					:item="tr"
					:editData="editData"
					:openConfirm="openConfirm"
					:createAdminResource="createAdminResource"
				/>
			</div>
		</div>
		<vs-pagination :total="totalPages" :max="itemsPerPage" v-model="currentPage" />
	</div>
</template>

<script>
import moduleCompany from "@/store/company/moduleCompany.js";
import Company from "@/models/Company.js";
import CompanyListViewItemCardVue from "./CompanyListViewItemCard.vue";

export default {
	name: "CompanyListView",
	components: {CompanyListViewItemCardVue},
	data() {
		return {
			selected: [],
			itemsPerPage: 12,
			isMounted: false,
			itemSelected: null,
			currentPageLocal: 1,
			searchQuery: null,
			searchField: "Name",
			isExactly: false,
			resourceListConfig: {
				rowSelection: "single",
				activeCheckbox: true,
				columns: ["identification", "name", "lastname", "username", "email", "alias"],
				actionDropdown: false,
				popupMode: false,
				link: false,
				importMode: true,
			},
		};
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		listCompanies() {
			return [...this.$store.state.moduleCompany.companies].reverse();
		},
		listCompaniesPage() {
			const data = [...this.$store.state.moduleCompany.companies].reverse();
			// Calculate the index of the first item on the current page
			const startIndex = (this.currentPage - 1) * this.itemsPerPage;
			// Calculate the index of the last item on the current page
			const endIndex = startIndex + this.itemsPerPage;

			if (!this.searchQuery || this.searchQuery.length <= 0) {
				// Slice the contentList array to get the items for the current page
				return data.slice(startIndex, endIndex);
			} else {
				return this.listCompanies;
			}
		},
		queriedItems() {
			return this.listCompanies.length;
		},
		totalPages() {
			// Calculate the total number of pages
			if (!this.searchQuery || this.searchQuery.length <= 0) {
				return Math.ceil(this.listCompanies.length / this.itemsPerPage);
			} else {
				return Math.ceil(this.listCompaniesPage.length / this.itemsPerPage);
			}
		},
		searchSelected() {
			return this.$t(`CompanyModule.Table.${this.searchField}`);
		},
	},
	methods: {
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteCompany"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/removeItem", id)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyDelete"),
						text: this.$t("TextConfirmCompanyDelete"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		editData(data) {
			this.$emit("selectedCompanyEmit", new Company(data), "update");
		},
		createAdminResource(data) {
			this.$emit("selectedCompanyCreateAdminResourceEmit", data, "createAdmin");
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		setSearchField(val) {
			this.searchField = val;
		},
		searchCompany() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				nit: this.searchField === "Nit" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				address: this.searchField === "Address" ? searchQueryList : [],
				city: this.searchField === "City" ? searchQueryList : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/fetchCompanyFilter", dataPage)
				.then((res) => {
					this.closeLoading();
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		refresh() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.getCompany();
		},
		getCompany() {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/fetchDataListItems")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_company"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
	created() {
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		this.getCompany();
	},
	async mounted() {
		this.isMounted = true;
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_company;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_company;
		}
	},
};
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
